import { useContext } from 'react';
import { ModelsService } from '../../services/ModelsService';
import { AppContext } from '../../state/AppContextProvider';
import { NewsItemSimple } from '../news/NewsItemSimple';
import { NewsListSimple } from '../news/NewsListSimple';

const NewsResults = ({ items }) => {
  const { state } = useContext(AppContext);

  const mainHouseId = state.mainHouse?.id || 0;
  const newsList = items.map((it) =>
    ModelsService.toNewsView(
      mainHouseId,
      ModelsService.getUserActiveHouse(state.user)?.term_id || 0,
      it,
      state.allHouses,
      state.allServices,
      state.user?.acf.locale
    )
  );

  return (
    <NewsListSimple
      news={newsList}
      baseUrl={'/search'}
      itemRenderer={NewsItemSimple}
    />
  );
};

export default NewsResults;
